<template>
    <div style="height: 500px;overflow: auto;">
        <!-- <virtual-list :size="treeItemHeight" :remain="visibleTreeItems" :data-key="'id'"> -->

            <el-tree :data="data" show-checkbox default-expand-all :props="defaultProps"
                @node-click="handleNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">


                    <span @contextmenu.prevent="onContextmenu" >{{ node.label }}</span>

                    </span>
                </el-tree>
        <!-- </virtual-list> -->
    </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'

 
export default {
    components: {
        'virtual-list': VirtualList
    },
    data() {
        return {
            treeItemHeight: 24, // 每个树项的高度
            visibleTreeItems: 10, // 可视区域内的树项数量
            data: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        };
    },
    methods: {
        onContextmenu(event){
            this.$contextmenu({
        items: [
          {
            label: "返回(B)",
            onClick: () => {
              this.message = "返回(B)";
              console.log("返回(B)");
            }
          },
          { label: "前进(F)", disabled: true },
          { label: "重新加载(R)", divided: true, icon: "el-icon-refresh" },
          { label: "另存为(A)..." },
          { label: "打印(P)...", icon: "el-icon-printer" },
          { label: "投射(C)...", divided: true },
          {
            label: "使用网页翻译(T)",
            divided: true,
            minWidth: 0,
            children: [{ label: "翻译成简体中文" }, { label: "翻译成繁体中文" }]
          },
          {
            label: "截取网页(R)",
            minWidth: 0,
            children: [
              {
                label: "截取可视化区域",
                onClick: () => {
                  this.message = "截取可视化区域";
                  console.log("截取可视化区域");
                }
              },
              { label: "截取全屏" }
            ]
          },
          { label: "查看网页源代码(V)", icon: "el-icon-view" },
          { label: "检查(N)" }
        ],
        event,
        //x: event.clientX,
        //y: event.clientY,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 230
      });
      return false;
        },
        handleNodeClick(data) {
            console.log(data);
        }
    },
    mounted() {
        //axios get 请求
        // axios.get('http://localhost:8000/tree').then(function (response) {
        //     // console.log(response.data);
        //     this.data = response.data;
        // }.bind(this));
    }

};
</script>

<style>
.tree-container {
    height: 500px;
    /* 设置容器高度以支持滚动 */
    overflow-y: auto;
    /* 容器需要滚动 */
}
</style>